import { useCookies } from 'react-cookie';
import { useTranslation } from 'react-i18next';
import { DEALER_DATA_COOKIE_NAME } from '../../../utils/constants';
const useGetDisclaimer = () => {
    const { t } = useTranslation();
    const [cookies] = useCookies([DEALER_DATA_COOKIE_NAME]);
    const dealerData = cookies === null || cookies === void 0 ? void 0 : cookies.dealerData;
    const isDealerSelected = !!(dealerData === null || dealerData === void 0 ? void 0 : dealerData.dealerCode);
    const isEvDealer = !!(dealerData === null || dealerData === void 0 ? void 0 : dealerData.evDealer);
    if (isDealerSelected) {
        if (!isEvDealer) {
            return t('Sub-apps.Dealers.evNotAvailableDealerText');
        }
        // TODO: SCC-8853 Honda-specific when dealer is not in user's province
    }
    return t('Sub-apps.Dealers.dealersInventoryText');
};
export default useGetDisclaimer;
